import stringHash from 'string-hash';
import { searchKeywordRegex } from "./validationRegexes";

// Hash a javascript object using JSON.stringify
// src: https://github.com/Khan/aphrodite/blob/master/src/util.js#L172
export var hashObject = function hashObject(object) {
  return stringHash(JSON.stringify(object)).toString(36);
};
var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
export function escapeStringRegex(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  return str.replace(matchOperatorsRe, '\\$&');
}
export function sanitizeSearchKeyword(keyword) {
  if (typeof keyword === 'string') {
    return keyword.replace(searchKeywordRegex, '').trim();
  }
  return '';
}